(function ( $ ) {
  'use strict';

  function is_half_in_viewport( $element ) {
    let
      rect           = $element[0].getBoundingClientRect(),
      _window_height = $(window).height(),
      _window_width  = $(window).width(),
      _inside_top    = (rect.top < _window_height * 0.75),
      _inside_bottom = (rect.bottom > _window_height * 0.25),
      _inside_left   = (rect.left < _window_width * 0.75),
      _inside_right  = (rect.right > _window_width * 0.25);

    return (
      _inside_top &&
      _inside_bottom &&
      _inside_left &&
      _inside_right
    );
  }

  // if ( $('#has-countdown').length ) { }

  $(document).ready(function () {

  });

  $(window).scroll(function () {
    if ( $('#has-countdown').length ) {
      let _is_countdown_active = $('#has-countdown').hasClass('active');
      if ( is_half_in_viewport($('#has-countdown')) && _is_countdown_active === false ) {
        $('#has-countdown')
          .addClass('active');
        $('.cta-section .custom-content .countdown .number')
          .incrementalCounter();
      }
    }
  });
})(jQuery);